import React from "react"
import Drawer from "@mui/material/Drawer"
import Divider from "@mui/material/Divider"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemText from "@mui/material/ListItemText"
import { connect } from "react-redux"
import { compose } from "redux"
import PropTypes from "prop-types"
import { isEmpty } from "../../actions/globalUiActions"

import { handleSignout } from "../../actions/userActions"
import MenuDrawerItems from "./MenuDrawerItems"

const MenuDrawer = ({
  drawerOpen,
  handleRouteClicked,
  auth,
  profile,
  // eslint-disable-next-line @typescript-eslint/no-shadow
  handleSignout,
}) => (
  <Drawer
    anchor="right"
    open={drawerOpen}
    onClose={handleRouteClicked}
    data-cy="menu-drawer"
  >
    <List>
      <MenuDrawerItems handleRouteClicked={handleRouteClicked} />
      {!isEmpty(auth) ? (
        <>
          <ListItem button onClick={() => handleRouteClicked("/profile")}>
            <ListItemText primary="Your Profile" />
          </ListItem>
          <ListItem
            button
            onClick={() => {
              handleSignout()
              handleRouteClicked("/")
            }}
          >
            <ListItemText primary="Sign Out" />
          </ListItem>
        </>
      ) : (
        <>
          <ListItem button onClick={() => handleRouteClicked("/profile")}>
            <ListItemText primary="Sign In" />
          </ListItem>
        </>
      )}
      {!isEmpty(auth) && !isEmpty(profile) && profile.isAdmin ? (
        <div>
          <Divider />
          <ListItem button onClick={() => handleRouteClicked("/admin/super")}>
            <ListItemText primary="Admin" />
          </ListItem>
        </div>
      ) : null}
      {!isEmpty(auth) && !isEmpty(profile) && profile.isInstructor ? (
        <div>
          <Divider />
          <ListItem
            button
            onClick={() => handleRouteClicked("/admin/instructor")}
          >
            <ListItemText primary="Instructor Admin" />
          </ListItem>
        </div>
      ) : null}
    </List>
  </Drawer>
)

MenuDrawer.propTypes = {
  drawerOpen: PropTypes.bool.isRequired,
  handleRouteClicked: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  handleSignout: PropTypes.func.isRequired,
}

export default compose(
  connect(({ firebase: { auth, profile } }) => ({ auth, profile }), {
    handleSignout,
  }),
)(MenuDrawer)
